import React, { useState } from 'react';
import { iconList, FA6 } from './iconList';
import SingleIcon from './SingleIcon';
import {
  ArrowLongLeftIcon,
  ArrowLongRightIcon,
} from '@heroicons/react/20/solid';

const IconSelector = ({ value, onChange, isOpen, onOpen, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0); // Aktuelle Seite
  const iconsPerPage = 48; // Anzahl der Icons pro Seite

  // Filter icons based on search term
  const filteredIcons = iconList.filter((icon) =>
    icon.searchTerms.some((term) =>
      term.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  // Berechne den Start- und Endindex basierend auf der aktuellen Seite
  const startIndex = page * iconsPerPage;
  const endIndex = startIndex + iconsPerPage;

  // Icons für die aktuelle Seite
  const currentIcons = filteredIcons.slice(startIndex, endIndex);

  // Handle icon selection
  const handleIconSelect = (iconName) => {
    onChange(iconName); // Notify parent of the selected icon
    onClose(); // Close the search overlay after selection
  };

  // Get the selected icon component, or a default one if none is selected
  const SingleIcon = value ? FA6[value] : FA6['FaPhone'];

  return (
    <div className="relative">
      {/* Icon Display Mode */}
      {!isOpen && (
        <div
          className="flex items-center justify-start cursor-pointer"
          onClick={onOpen} // Trigger opening of the search overlay
        >
          <div className="rounded-md border-0 p-2 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-svisit-primary-600">
            {SingleIcon && <SingleIcon size={24} />}
          </div>
        </div>
      )}

      {/* Search Mode (Overlay) */}
      {isOpen && (
        <div className="icon-search-overlay absolute top-0 left-0 w-full h-full bg-white shadow-lg z-10">
          {/* Search input */}
          <input
            type="text"
            placeholder="Suche nach Icons..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="block w-full rounded-md border-0 px-3 py-1.5 mb-4 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
          />

          {/* Icon Grid */}
          <div className="icon-grid grid grid-cols-4 gap-4">
            {currentIcons.map((icon) => {
              const SingleIcon = FA6[icon.name];
              if (!SingleIcon) return null; // Skip if icon not found

              return (
                <div
                  key={icon.name}
                  className="icon-item flex flex-col items-center cursor-pointer"
                  onClick={() => handleIconSelect(icon.name)} // Select the icon and close the overlay
                >
                  <SingleIcon size={24} />
                </div>
              );
            })}
          </div>

          {/* Pagination Controls */}
          <div className="flex justify-between mt-4">
            <div className="-mt-px flex w-0 flex-1 cursor-pointer">
              {page === 0 ? (
                ''
              ) : (
                <a
                  onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                  disabled={page === 0}
                  className="inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-900 hover:border-gray-300 hover:text-gray-700 cursor:pointer"
                >
                  <ArrowLongLeftIcon
                    className="mr-3 h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                  Zurück
                </a>
              )}
            </div>
            <div className="-mt-px flex w-0 flex-1 justify-end cursor-pointer">
              {endIndex >= filteredIcons.length ? (
                ''
              ) : (
                <a
                  onClick={() =>
                    setPage((prev) =>
                      endIndex < filteredIcons.length ? prev + 1 : prev
                    )
                  }
                  hidden={endIndex >= filteredIcons.length}
                  className="inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-900 hover:border-gray-300 hover:text-gray-700"
                >
                  Weiter
                  <ArrowLongRightIcon
                    className="ml-3 h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </a>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default IconSelector;
